import { LightningElement, api, wire } from "lwc";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import { attrToBool } from "common/helpers";

import * as locales from "./locales";

const validVariants = [
  "info",
  "error",
  "warning",
  "offline",
  "preview",
  "feature",
] as const;

export type Variant = typeof validVariants[number];

const icons = {
  info: "info",
  warning: "warning",
  error: "error",
  offline: "offline",
  preview: "preview",
  feature: "magicwand",
};

export default class extends LightningElement {
  @api variant: Variant = "info";
  @api dismissible: boolean | string | null = null;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  variantValue() {
    if (validVariants.includes(this.variant)) {
      return this.variant;
    } else {
      return "info";
    }
  }

  private get isDismissible() {
    return attrToBool(this.dismissible);
  }

  private get iconAssistiveText() {
    // eslint-disable-next-line
    return this.labels[this.variantValue()];
  }

  private get iconSymbol() {
    return icons[this.variantValue()];
  }

  private get className() {
    return `alert alert--${this.variantValue()} ${
      (this.isDismissible && "dismissible") || ""
    }`;
  }

  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
}
